import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import axios from 'axios';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faTachometerAlt, faTools } from '@fortawesome/free-solid-svg-icons';
import { AuthenticationService } from '../../Services/AuthenticationService';

const styles = theme => ({
    palette: {
        primary: {main: '#FFF'},
        secondary: {main: '#03a9f4'},
        contrastText: '#fff',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 15px',
        ...theme.mixins.toolbar,
    },
});

let globalProps;

class NavigationDrawerMobile extends React.Component {
    constructor(props){
        super(props);
        const authService = AuthenticationService.getInstance();
        
        this.state = {
            jwtToken: authService.getToken(),
            userId: authService.getUserId(),
            permissions: localStorage.getItem('permissions'),
        };
        
        const token = authService.getToken();
        if (token) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        }
    }

    logout = () => {
        AuthenticationService.getInstance().logout();
        this.props.history.push('/login');
    };

    myDashboard = () => {
        this.props.history.push('/dashboard');
    };

    adminDashboard = () => {
        this.props.history.push('/admin/assemblies');
    };

    systemAdminPanel = () => {
        this.props.history.push('/admin/system');
    };

    isActive = (path) => {
        return this.props.location.pathname === path || this.props.location.pathname.startsWith(path + '/');
    };

    render(){
        const user = AuthenticationService.getInstance().getUser();

        let adminDash;
        if (user.isAdministrator)
            adminDash =
                <Tooltip title="Admin Dashboard" aria-label="Admin Dashboard" placement="right" TransitionComponent={Zoom}>
                    <ListItem button onClick={this.adminDashboard} className={`navItemMobile ${this.isActive('/admin') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faTools} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                    </ListItem>
                </Tooltip>;
        const myDashboard =
                <Tooltip title="My Dashboard" aria-label="My Dashboard" placement="right" TransitionComponent={Zoom}>
                    <ListItem button onClick={this.myDashboard} className={`navItemMobile ${this.isActive('/dashboard') ? 'active' : ''}`}>
                        <span className="navIcon"><FontAwesomeIcon icon={faTachometerAlt} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                    </ListItem>
                </Tooltip>;
        const logout =
            <Tooltip title="Logout" aria-label="Logout" placement="right" TransitionComponent={Zoom}>
                <ListItem button onClick={this.logout} className="navItemMobile">
                    <span className="navIcon"><FontAwesomeIcon icon={faSignOutAlt} size="1x" style={{width: 28, fontSize: 18, marginLeft: -3}}/></span>
                </ListItem>
            </Tooltip>;

        return (
            <List style={{color: '#005677', display: 'flex'}}>
                { adminDash }
                { myDashboard }
                { logout }
            </List>
        )
    }
}

NavigationDrawerMobile.propTypes = {
    classes: PropTypes.object.isRequired,
};

NavigationDrawerMobile = withRouter(NavigationDrawerMobile);
export default withStyles(styles)(NavigationDrawerMobile);
